import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-add-solution-form',
    templateUrl: './add-solution-form.component.html',
    styleUrls: ['./add-solution-form.component.scss'],
    standalone: false
})
export class AddSolutionFormComponent  implements OnInit {

  @Input() set data(data: any) {
    this.editData = data;
  };
  private destroyRef = inject(DestroyRef);

  @Input() edit;
  editData: any;
  Constants = Constants;
  title: string;
  createSolutionForm: FormGroup;
  mediaForm: FormGroup[] = [];
  lineOfBusinessOptions: any;
  regionOptions: any;
  categoryOptions: any;
  statusOptions: any;
  mediaCategoryOptions: any;
  occurrences: any[];
  index: number;
  formConfig: any;
  isLoading = false;

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private solutionsService: SolutionsService,
    private toastrService: ToastrService,
    private dialog: MatDialog) { 
      
    }

  ngOnInit(): void {
    this.title = this.edit ? translate('SOLUTIONS.EDIT_SOLUTION') : translate('SOLUTIONS.ADD_NEW_SOLUTION');
    this.lineOfBusinessOptions = [
      {value: 'sme-banking' , selected: false}
    ];

    this.regionOptions = [
      {value: 'APAC' , selected: false},
      {value: 'APAC_2' , selected: false},
      {value: 'AUSTRALIA' , selected: false},
      {value: 'AUSTRALIA_2' , selected: false},
      {value: 'BRAZIL' , selected: false},
      {value: 'BRAZIL_2' , selected: false},
      {value: 'CANADA' , selected: false},
      {value: 'EUROPE' , selected: false},
      {value: 'FRANCE' , selected: false},
      {value: 'GERMANY' , selected: false},
      {value: 'INDIA' , selected: false},
      {value: 'JAPAN' , selected: false},
      {value: 'KOREA' , selected: false},
      {value: 'NORWAY' , selected: false},
      {value: 'SOUTH_AFRICA' , selected: false},
      {value: 'SWEDEN' , selected: false},
      {value: 'SWITZERLAND' , selected: false},
      {value: 'UK' , selected: false},
      {value: 'NORTH_AMERICA' , selected: false},
      {value: 'NORTH_AMERICA_2' , selected: false},
      {value: 'NORTH_AMERICA_3' , selected: false},
      {value: 'NORTH_AMERICA_4' , selected: false},
      {value: 'UAE' , selected: false}
    ];

    this.categoryOptions = [
      {value: 'SaaS' , selected: false},
      {value: 'BSG' , selected: false},
      {value: 'Demo' , selected: false},
      {value: 'Hosted' , selected: false},
    ];

    this.statusOptions = [
      {value: 'dev' , selected: false},
      {value: 'test' , selected: false},
      {value: 'published' , selected: false},
      {value: 'sunset' , selected: false},
      {value: 'deprecated' , selected: false},
      {value: 'comingsoon' , selected: false}
    ];

    this.mediaCategoryOptions = [
      {value: 'marketing' , selected: false},
      {value: 'tutorial' , selected: false}
    ];

    this.createForm();
  }

  getDeployment(): any {
    let failed = false;
    if (!FormUtilService.validateForm(this.createSolutionForm)) {
      return;
    }
    this.mediaForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    if (failed) {
      return;
    } else {
      return this.createSolutionForm.getRawValue();
    }
  }

  /**
   * Adds a new solution to the solution list when user clicks on submit button along with the confirmation popup.
   */
  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('ADD_SOLUTION.TITLE'),
        message:translate('ADD_SOLUTION.MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          let mediaList = [];
          this.mediaForm.forEach(media => {
            mediaList = [...mediaList, media.getRawValue()];
          });
          const obj = this.getDeployment();
          obj.media = mediaList;
          const formData = obj;
          this.isLoading = true;
          formData.integrations = typeof(formData.integrations) === 'string' ? formData.integrations.split(',') : formData.integrations;
            formData.keywords = typeof(formData.keywords) === 'string' ? formData.keywords.split(',') : formData.keywords;
            this.solutionsService.postSolution(formData)
            // eslint-disable-next-line rxjs-angular/prefer-takeuntil
            .subscribe(data => {
              if (data) {
                this.isLoading = false;
                this.toastrService.success(translate('ADD_SOLUTION.SOLUTION_ADDED'));
                this.sidenavService.closeRightSidenav(obj);
              }
            },
            (error) => {
              this.isLoading = false;
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.ADD_SOLUTION_FAILED'),
                  description: errorMessage
                }
              });
            });
          }
        });
  }

  /**
   * Edits a solution to the solution list when user clicks on submit button along with the confirmation popup.
   */
  editSolution(): void {
    if (!this.getDeployment()) {
      return;
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SOLUTIONS.TITLE'),
        message:translate('SOLUTIONS.MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        let mediaList = [];
        this.mediaForm.forEach(media => {
          mediaList = [...mediaList, media.getRawValue()];
        });
        const obj = this.getDeployment();
        obj.media = mediaList;
        const formData = obj;
        this.isLoading = true;
        formData.integrations = typeof(formData.integrations) === 'string' ? formData.integrations.split(',') : formData.integrations;
        formData.keywords = typeof(formData.keywords) === 'string' ? formData.keywords.split(',') : formData.keywords;
        formData.id = this.editData?.id;
        this.solutionsService.putSolution(formData)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(response => {
                if (response) {
                  this.isLoading = false;
                  this.toastrService.success(translate('ADD_SOLUTION.SOLUTION_EDITED'));
                  this.sidenavService.closeRightSidenav(obj);
                }
              },
              (error) => {
                this.isLoading = false;
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '630px',
                  panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.EDIT_SOLUTION_FAILED'),
                    description: errorMessage
                  }
                });
              });
            }
          });
  }

  createForm(): void {
    const formConfig: any = {
      name: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
      shortDescription: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(256)]],
      longDescription: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(2048)]],
      tagline: ['', [Validators.required, Validators.minLength(32), Validators.maxLength(64)]],
      punchline: ['', [Validators.required, Validators.minLength(64), Validators.maxLength(128)]],
      lineOfBusiness: [undefined, [Validators.required]],
      regionalAvailability: [undefined, [Validators.required]],
      category: [undefined, [Validators.required]],
      status: [undefined, [Validators.required]],
      integrations: ['', [Validators.required]],
      label: ['', [Validators.required]],
      keywords: ['', [Validators.required]],
      iconHref: ['', [Validators.required, Validators.pattern('^(http|https)(.+)(jpg|png)$')]]
    };
    this.createSolutionForm = this.formBuilder.group(formConfig);

    if (this.editData) {
      const keys = Object.keys(formConfig);
      const values = this.editData;
      keys.forEach(key => {
        if (values[key]) {
          this.createSolutionForm.get(key).setValue(values[key]);
        }
      });
      this.addMediaForm();
    }
  }

  createMediaForm(): void {
    this.formConfig = {
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
      category: [undefined, [Validators.required]],
      mediaHref: ['', [Validators.required]],
      iconHref: ['', [Validators.required]],
      sequenceNumber: ['', [Validators.required]],
    };
    this.mediaForm[this.index] = this.formBuilder.group(this.formConfig);
  }

  addMediaForm(): void {
    if (this.editData.media?.length > 0) {
      this.editData.media?.forEach(item => {
        this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
        this.createMediaForm();
        const keys = Object.keys(this.formConfig);
        const values = item;
        keys.forEach(key => {
          if (values[key]) {
            this.mediaForm[this.index].get(key).setValue(values[key]);
          }
        });
        this.occurrences = this.occurrences && this.occurrences.length !== 0 ?
          [...this.occurrences, this.occurrences[this.occurrences.length - 1] + 1] : [0];
      });
    }
  }

  addMediaOccurrence(): void {
    this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
    this.createMediaForm();
    this.occurrences = this.occurrences && this.occurrences.length !== 0 ?
      [...this.occurrences, this.occurrences[this.occurrences.length - 1] + 1] : [0];

  }

  deleteMediaOccurrence(i): void {
    this.occurrences.splice(-1, 1);
    this.index = this.index - 1;
    this.mediaForm.splice(i, 1);
    this.mediaForm = this.mediaForm;
  }

}
